import { render, staticRenderFns } from "./ClientPackageHistoryDialog.vue?vue&type=template&id=04dba7a0"
import script from "./ClientPackageHistoryDialog.vue?vue&type=script&lang=js"
export * from "./ClientPackageHistoryDialog.vue?vue&type=script&lang=js"
import style0 from "./ClientPackageHistoryDialog.vue?vue&type=style&index=0&id=04dba7a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports